import React, { memo } from 'react';
import classNames from 'classnames';
import styles from './WallpaperCategoryNav.module.less';

export default memo(
  ({
    list = [],
    col,
    handleCategory,
    status,
    active,
    text,
    keyId,
    keyName,
    handleMore,
    keyWord,
  }) => {
    if (list.length < 1) {
      return null;
    }
    return (
      <div className={styles.label_container}>
        <div className={styles.label_row_class}>
          <div className={classNames(styles.grid_item_start)}>{text}：</div>
          <div
            className={classNames(styles.grid_item_second, {
              [styles.active]: active === (list[0] && list[0][keyId]),
            })}
          >
            <span onClick={handleCategory(list[0] && list[0][keyId])}>
              {list[0] && list[0][keyName]}
            </span>
          </div>
        </div>
        {list.length > 1 && (
          <div
            className={styles[`label_row_${keyWord}_content${status === 'collapse' ? col : col}`]}
          >
            {(status === 'open' ? list : list.slice(0, col + 1)).map((item, index) => {
              if (index !== 0) {
                return (
                  <div
                    key={item[keyId]}
                    className={classNames(styles.label_item, {
                      [styles.active]: active === item[keyId],
                    })}
                  >
                    <div onClick={handleCategory(item[keyId])}>
                      {item.colorValue && (
                        <div
                          className={styles.label_color_block}
                          style={{ backgroundColor: item.colorValue }}
                        />
                      )}
                      <span>{item[keyName]}</span>
                    </div>
                  </div>
                );
              }
              return null;
            })}
          </div>
        )}

        {status === 'collapse' && list.length >= 9 && (
          <div className={styles.label_container_btn} onClick={handleMore(keyWord)}>
            更多
            <i className={classNames('iconfont icon-arrow_down_small', styles.icon_label)} />
          </div>
        )}
        {status === 'open' && list.length >= 9 && (
          <div className={styles.label_container_btn} onClick={handleMore(keyWord, col)}>
            收起
            <i className={classNames('iconfont icon-arrow_up_small', styles.icon_label)} />
          </div>
        )}
      </div>
    );
  },
);
